<template>
 <v-dialog v-model="visible" persistent max-width="500px">
   <v-card>
     <v-card-text>
       <v-form ref="itemForm" v-model="isValid" v-if="visible">
           <v-text-field
            label="Price"
            v-model="newItem.price"
            :rules="priceRules"
            required
           ></v-text-field>
          <v-text-field
              label="External Id"
              v-model="newItem.externalId"
              :rules="externalIdRules"
          ></v-text-field>
          <v-checkbox
            label="Hidden"
            v-model="newItem.hidden"
          ></v-checkbox>
          <v-select
            :items="availableContractors"
            v-model="newItem.contractorId"
            label="Service of Client Contractor"
            item-value="id"
            item-text="title"
            clearable
          ></v-select>
           <v-alert
             :value="hasError"
             type="error"
             outline
           >
             {{ errorMessage }}
           </v-alert>
           <v-btn
             :disabled="!isValid"
             @click="handleOkClick"
           >
             Save
           </v-btn>
           <v-btn @click="handleCancelClick">Cancel</v-btn>
         </v-form>
     </v-card-text>
   </v-card>
 </v-dialog>
</template>

<style scoped>
.v-text-field {
    padding-top: 0px!important;
}
</style>

<script>
import _ from 'lodash'
import api from '../../api'
import {extractErrorToString} from '../../helpers/api'
import {validateStringLength} from '../../helpers/validation'
import {isNumeric} from '../../helpers/types'

const emptyItem = {
  id: null,
  price: null,
  currency: null,
  externalId: null,
  hidden: null,
  contractorId: null
}

export default {
  name: 'client-creation-form',
  props: {
    visible: {
      type: Boolean
    },
    selectedItem:{
      type: Object
    },
    availableContractors: {
      type: Array
    }
  },
  data () {
    return {
      draftOriginatorClientIds: null,
      hasError: null,
      loading: false,
      isValid: false,
      errorMessage: null,
      newItem: _.clone(emptyItem),
      externalIdRules: [
        _.partial(validateStringLength, _, 255, 'The length of the externalId should be no more than 2000 characters')
      ],
      priceRules: [
        (value) => {
          let numeric = isNumeric(value)

          if (!numeric) {
            return 'Price must be numeric value'
          }

          if (parseFloat(value) < 0) {
            return 'Price value must be positive or zero'
          }

          return true
        }
      ]
    }
  },
  beforeCreate () {
    
  },
  watch: {
    visible: function(){
      if (this.visible && this.selectedItem){
        this.newItem = _.clone(this.selectedItem)
      }
    }
  },
  mounted () {
  },
  methods: {
    async handleOkClick () {
      this.hasError = null
      this.errorMessage = null

      if (this.newItem.id){
        try {
          let updatedItem = await api.updateClientService({
            id: this.newItem.id,
            price: parseFloat(this.newItem.price),
            currency: this.newItem.currency,
            externalId: this.newItem.externalId,
            hidden: this.newItem.hidden,
            contractorId: this.newItem.contractorId
          })
        this.isEditMode = false
        this.$emit('updated', updatedItem)
        this.resetForm()
        } catch (e) {
          this.hasError = true
          this.errorMessage = extractErrorToString(e, 'Unable to update client service')
        }

        return
      }
    },
    handleCancelClick () {
      this.resetForm()
    },
    resetForm () {
      this.$emit('close')
      this.hasError = null
      this.errorMessage = null
      this.$refs.itemForm.reset()
      this.newItem = _.clone(emptyItem)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/ClientServiceForm.vue